import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/present-value-calculator',
  component: () => import('../../routes/PresentValue.svelte'),
  card: {
    id: 'present-value-calculator',
    title: 'Present Value Calculator',
    description: 'Calculate how much you need to invest today to reach a future goal, accounting for compound interest.',
    icon: 'history',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/present-value-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Present Value Calculator – How Much to Invest Today for Future Goals',
    description: 'Free present value calculator. Determine how much to invest now to reach a specific future amount, accounting for compound interest and your expected rate of return.',
  },
};

export default meta;
